export default __webpack_public_path__ + "static/individuals-2-5ef9abb500cc85a23e849a53634f5e41.jpg";